import usageData from "routes/SnippetsPage/generated/usage.json";

type UsageEntry = {
  file: string;
  line: number;
};

type UsageMap = Record<string, UsageEntry[]>;

type UsageDataFile = {
  generatedAt: string | null;
  usage: UsageMap;
};

const typedData = usageData as unknown as UsageDataFile;

type UsageListProps = {
  snippetId: string;
};

/**
 * スニペット ID に紐づく参照箇所一覧を表示する。
 * @param {UsageListProps} props snippetId を受け取る
 * @return {JSX.Element} 参照箇所の折りたたみ表示
 */
export const UsageList = ({ snippetId }: UsageListProps): JSX.Element => {
  const entries = typedData.usage[snippetId] ?? [];
  const generatedAt = typedData.generatedAt;

  if (entries.length === 0) {
    return (
      <details className="text-xs text-base-content/60">
        <summary className="cursor-pointer">
          使用箇所 (0)
          {generatedAt ? "" : " — usage.json 未生成"}
        </summary>
        <p className="mt-2 text-base-content/50">
          参照箇所が見つかりませんでした。
          <br />
          最新状態に更新するには
          <code className="mx-1 px-1 bg-base-200 rounded">
            node scripts/generate-snippet-usage.js
          </code>
          を実行してください。
        </p>
      </details>
    );
  }

  return (
    <details className="text-xs">
      <summary className="cursor-pointer text-base-content/70">
        使用箇所 ({entries.length})
      </summary>
      <ul className="mt-2 space-y-0.5 max-h-60 overflow-y-auto text-base-content/70 font-mono">
        {entries.map(entry => (
          <li key={`${entry.file}:${entry.line}`}>
            {entry.file}:{entry.line}
          </li>
        ))}
      </ul>
      {generatedAt && (
        <p className="mt-2 text-[10px] text-base-content/40">
          generated at {generatedAt}
        </p>
      )}
    </details>
  );
};
